import { Box } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import TheGuarantorsLogoCompact from '@/assets/images/logo-compact-grey.svg';
import { theme } from '@theguarantors/tg-package-material-ui';

interface MenuVisibilityControlProps {
  menuOpen: boolean;
  openMenu: () => void;
  closeMenu: () => void;
  baseTextColor: string | undefined;
  baseBackgroundColor: string;
  isMobile: boolean;
}

const MenuVisibilityControl = ({
  menuOpen,
  openMenu,
  closeMenu,
  baseTextColor,
  baseBackgroundColor,
  isMobile,
}: MenuVisibilityControlProps) => {
  return (
    <Box
      sx={{
        whiteSpace: 'nowrap',
        maxWidth: menuOpen || isMobile ? '290px' : '72px',
        width: '100%',
        transition: isMobile ? 0 : 'all 0.25s linear',
        ['svg']: {
          fill: `${baseTextColor} !important`,
          fontSize: '22px',
        },
        ['&:hover #tg-navbar-logo']: menuOpen
          ? {}
          : {
              borderColor: `${theme.palette.neutralGrey[400]}`,
            },
        ['&:hover #tg-navbar-logo .logo-image']: menuOpen ? {} : { display: 'none' },
        ['&:hover #tg-navbar-logo .chevron-icon']: menuOpen ? {} : { display: 'flex' },
      }}
    >
      <Box
        id="tg-navbar-logo"
        role="button"
        aria-label="TheGuarantors"
        onClick={openMenu}
        sx={{
          width: '24px',
          transition: 'all 0.1s linear',
          minWidth: '24px',
          height: '24px',
          minHeight: '24px',
          margin: '16px 18px',
          padding: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          borderRadius: '8px',
          border: `1px solid ${baseBackgroundColor}`,
          ':hover': menuOpen
            ? {}
            : {
                backgroundColor: `rgba(0,0,0,0.1)`,
              },
        }}
      >
        <Box
          className="logo-image"
          sx={{
            width: '24px',
            height: '24px',
            backgroundImage: `url("${TheGuarantorsLogoCompact}")`,
            backgroundSize: '24px 24px',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        />
        <ChevronRight
          className="chevron-icon"
          sx={{
            display: 'none',
            color: baseTextColor || '#6D6D6D',
            fontSize: '24px',
          }}
        />
      </Box>
      <Box
        role="button"
        aria-label="TheGuarantors"
        onClick={closeMenu}
        sx={{
          display: menuOpen ? 'flex' : 'none',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          zIndex: 1000,
          right: 0,
          top: 0,
          height: '24px',
          width: '24px',
          margin: '16px',
          padding: '6px',
          border: `1px solid ${theme.palette.neutralGrey[400]}`,
          borderRadius: '8px',
          ':hover': {
            backgroundColor: `rgba(0,0,0,0.1)`,
          },
        }}
      >
        <ChevronLeft
          sx={{
            color: baseTextColor || '#6D6D6D',
            fontSize: '24px',
          }}
        />
      </Box>
    </Box>
  );
};

export default MenuVisibilityControl;
